// CacheKey df698c261ae3ffd9f2a5afa25054790b
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-PAYER": {
    simple_form: {
      labels: {
        care_form: {
          display_completed_date: "Assessment Date"
        },
        patient: {
          phone: "Cell Phone",
          secondary_phone: "Apartment Phone"
        },
        enrollment: {
          subscriber_id: "XOG Subscriber ID"
        }
      }
    }
  }
}

